import type { RegistrationSiteSettings } from '../../registration.types.ts';
import { PHONE_NUMBER } from './phoneNumber.ts';

const AU_POSTCODE_PATTERN = /^\d{4}$/;

const REGISTRATION: RegistrationSiteSettings = {
  country: PHONE_NUMBER.country,
  defaultPhonePrefix: PHONE_NUMBER.defaultPrefix,
  language: 'en-AU',
  phonePlaceholder: PHONE_NUMBER.placeholder,
  postcodePattern: AU_POSTCODE_PATTERN,
  states: [
    { label: 'New South Wales', value: 'NSW' },
    { label: 'Victoria', value: 'VIC' },
    { label: 'Queensland', value: 'QLD' },
    { label: 'South Australia', value: 'SA' },
    { label: 'Western Australia', value: 'WA' },
    { label: 'Tasmania', value: 'TAS' },
    { label: 'Northern Territory', value: 'NT' },
    { label: 'Australian Capital Territory', value: 'ACT' },
  ],
  defaultRegistrationSuccessPath: '/play',
  requirePrivacyPolicyAcceptance: false,
  marketingConsentFromPrivacyPolicy: true,
  mobileNationalNumberRegex: PHONE_NUMBER.nationalNumberRegex,
  collectsAddressLine2: false,
  showsStateSelect: false,
  showsGamblingMarketingPreferenceSteps: false,
  usesObRedirectForAcquisitionCode: false,
  isDailyFirstPeriodOrder: true,
  usesClassifiedRegistrationErrorStep: true,
  tracking: {
    termsCheckboxName: 'Agree',
    privacyCheckboxName: 'Marketing',
    successAttributes: 'marketing',
    depositLimitsStep: '5',
  },
};

export { REGISTRATION };
